module.exports = __webpack_public_path__ + "img/service-icon1.762e83cc.png";